import update from 'react/lib/update';

const initialState = {
	isFetching: false,
	canChangeUser: false,
	filter: {
		selectedTerms: []
	},
	users: [],
	pagination: { itemsPerPage: 15, currentPage: 1 },
	logs: {
		access_log: [],
		pagination: { itemsPerPage: 15, currentPage: 1 },
		filter: {
			selectedTerms: []
		}
	}
	
};

export default function lUsers(state = initialState, action) {
	switch (action.type) {

		case "IS_FETCHING":
			return update(state, { isFetching: { $set: action.bool } });
		case "SET_LIST_USERS":
			return update(state, { users: { $set: action.users } });
		case "SET_ACCESS_LOG":
			return update(state, { logs: { access_log: { $set: action.accessLog } } });
		case "SET_ACCESS_LOG_CURRENT_PAGE":
			return update(state, { logs: { pagination: { currentPage: { $set: action.currentPage } } } });
		case "SET_ACCESS_LOG_FILTER_TERMS":
			return update(state, { logs: { filter: { selectedTerms: { $set: action.terms } } } });
			
		case "SET_CAN_CHANGE_USER":
			return update(state, { canChangeUser: { $set: action.bool } });
		case "SET_USERS_CURRENT_PAGE":
			return update(state, { pagination: { currentPage: { $set: action.currentPage } } });
		case "SET_USERS_FILTER_TERMS":
			return update(state, { filter: { selectedTerms: { $set: action.terms } } });
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/state/gerenciarUsuarios/reducer.js